import { render, staticRenderFns } from "./OmniCardBody.vue?vue&type=template&id=0df86090&"
import script from "./OmniCardBody.vue?vue&type=script&lang=js&"
export * from "./OmniCardBody.vue?vue&type=script&lang=js&"
import style0 from "./OmniCardBody.vue?vue&type=style&index=0&id=0df86090&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports